import { Environment, EnvironmentName } from '@shared/models/platform/environment.models';

export const environment: Environment = {
  name: EnvironmentName.DEV,
  //apiUrl: 'http://localhost:3000/api',
  apiUrl: 'https://dev-feelbetr.wlcmapps.com/api',
};
